export function chatroomExists (state) {
  return (firebaseRoomCode) => {
    let index = state.chatrooms.findIndex((cr)=>cr.chat.firebase_code === firebaseRoomCode)
    return index !== -1
  }
}
